import React, { FormEvent, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ExternalIcon from '../../assets/icons/external-icon.svg';
import BinIcon from '../../assets/icons/bin-icon-gray-400.svg';
import calendarIcon from '../../assets/icons/calendar-icon.svg';

import ZahtjeviService from '../../service/ZahtjeviService';
import { Companies, DocumentFile, DocumentVariable, Zahtjev } from '../../common/types/types';
import { documentVariableNames } from '../../common/initialValues/initialValues';
import { DatePlusYear, pretvoriDatumuFormatTablice, pretvoriDatumuFormatTabliceSimple, searchRequestDate } from '../../common/utils/HelperFunction';
import DocumentImages from './DocumentImages';
import { documentConfirm } from '../../functions/documentFuctions';
import Calendar from 'react-calendar';
import { useAppSelector } from '../../store/hooks/hooks';
import Tippy from '@tippyjs/react';
import DeleteDocument from './DeleteDocument';

export const ManageDocument = () => {
  const reachedProcesses = useAppSelector((state) => state.processes.reachedProcesses);
  const reachedCompanies = useAppSelector((state) => state.companies.dohvaceniCompanies);
  const location = useLocation();
  const navigate = useNavigate();

  const [documentId, setDocumentId] = useState<string | number>(location.state?.documentId);
  const [documentName, setDocumentName] = useState<string | null>(location.state?.documentName);
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [companybyAltVat, setCompanyByAltVat] = useState<Companies | null>(null);

  let editable = location.state?.editableData; //update confirmed uneditable

  const [documentFiles, setDocumentFiles] = useState<DocumentFile[]>([]);
  const [documentVariables, setDocumentVariables] = useState<DocumentVariable[]>([]);

  const [modalOn, setModalOn] = useState<boolean>(true);
  const [activeCalendar, setActiveCalendar] = useState<number>(0);

  const invoiceDateCalendarRef = useRef<HTMLDivElement>(null);
  const invoiceDueDateCalendarRef = useRef<HTMLDivElement>(null);

  const invoiceDateIsInvalid = documentVariables.some((variable) => {
    const today = searchRequestDate(new Date(), true);
    if (variable.name === 'InvoiceDate' && variable.value === null) return true;
    return today && variable.name === 'InvoiceDate' && variable.value > today;
  });

  let invoiceDateValue: string | null = null;
  let invoiceDueDateValue: string | null = null;
  const invoiceDueDateIsInvalid = documentVariables.some((variable) => {
    const datePlusYear = DatePlusYear(new Date());
    if (variable.name === 'InvoiceDueDate' && variable.value === null) return true;
    if (variable.name === 'InvoiceDate') invoiceDateValue = variable.value;
    if (variable.name === 'InvoiceDueDate') invoiceDueDateValue = variable.value;
    if (invoiceDateValue && invoiceDueDateValue) {
      if (datePlusYear && invoiceDueDateValue >= invoiceDateValue && invoiceDueDateValue <= datePlusYear) {
        return false;
      } else return true;
    }
    return false;
  });
  const invoiceAmountRegex = /^-?\d+(\.\d{0,2})?$/;
  const invoiceSubtotalIsInvalid: boolean = documentVariables.some((variable) => {
    if (variable.name === 'InvoiceSubtotal') {
      if (invoiceAmountRegex.test(variable.value)) return false;
      else return true;
    }
  });
  const invoiceTotalIsInvalid: boolean = documentVariables.some((variable) => {
    if (variable.name === 'InvoiceTotal') {
      if (invoiceAmountRegex.test(variable.value)) return false;
      else return true;
    }
  });

  useEffect(() => {
    ZahtjeviService.getDocument(documentId).then((response) => {
      const data = response.data.Data[0];
      const files = response.data.Files;

      setDocumentFiles(files);

      const objectVariables: DocumentVariable[] = Object.keys(data).map((key: string) => {
        const name = `${key}`;
        const value: string | number | Date | null = data[key as keyof Zahtjev];
        return { name: name, value: value as string };
      });

      setDocumentFiles(files);
      setDocumentVariables(objectVariables);
      if (files.length > 0) setModalOn(false);
    });
  }, [documentId]);

  const goBack = () => {
    navigate('/');
  };

  useEffect(() => {
    let onMouseDown = (e: any) => {
      if (!invoiceDateCalendarRef.current?.contains(e.target) && !invoiceDueDateCalendarRef.current?.contains(e.target)) {
        setActiveCalendar(0);
      }
    };

    document.addEventListener('mousedown', onMouseDown);

    return () => {
      document.removeEventListener('mousedown', onMouseDown);
    };
  });

  const nextDocument = () => {
    setModalOn(true);
    const uploadedBy = documentVariables.find((variable) => variable.name === 'UploadedBy')?.value;

    ZahtjeviService.getZahtjevi()
      .then((response) => {
        const zahtjevi: Zahtjev[] = response.data.filter(
          (zahtjev: Zahtjev) => zahtjev.ID !== documentId && zahtjev.Status === 2 && zahtjev.UploadedBy === uploadedBy
        );
        // navigate('/manageDocument', { state: { documentId: zahtjevi[0].ID, documentName: zahtjevi[0].Name, editableData: editable } });
        if (zahtjevi[0]) {
          setDocumentId(zahtjevi[0].ID);
          setDocumentName(zahtjevi[0].Name);
          setModalOn(false);
        } else {
          goBack();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleConfirm = (event: FormEvent<HTMLFormElement>) => {
    event?.preventDefault();
    documentConfirm(documentId, documentVariables, goBack);

    // const fd = new FormData(event.target as HTMLFormElement);
    // const data: Record<string, string> = {};
    // fd.forEach((value, key) => {
    //   data[key] = value.toString();
    // });
    // console.log(data);

    //kod selecta i checkboxeva posebno dohvatiti:
    // const nameChackboxevaChannel = fd.getAll('nameCheckboxeva');
    // data.nameChackboxeva = nameChackboxevaChannel
  };

  const handleConfirmAndNext = () => {
    setModalOn(true);
    documentConfirm(documentId, documentVariables, nextDocument);
  };

  const openPDFInNewTab = () => {
    const file = documentFiles[0].content;
    // let pdfWindow = window.open('');
    // pdfWindow && pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(file) + "'></iframe>");
    if (file) {
      // Convert base64 to binary data
      const byteCharacters = atob(file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      // Create an object URL
      const objectURL = URL.createObjectURL(blob);

      // Open the PDF in a new window
      const pdfWindow = window.open('');
      if (pdfWindow) {
        pdfWindow.document.write(`<iframe width="100%" height="100%" src="${objectURL}"></iframe>
            </body>
          </html>
        `);
        pdfWindow.document.close();
      } else {
        console.error('Failed to open new window');
      }
    } else {
      console.error('No file content available');
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>, index: number, variable: DocumentVariable) => {
    const companyVAT = event.target.value;
    console.log(documentVariables);
    setDocumentVariables((prevDocumentVariables) => {
      const updatedDocumentVariables = [...prevDocumentVariables];
      updatedDocumentVariables[index] = { name: variable.name, value: event.target.value };

      return updatedDocumentVariables;
    });

    //Ukoliko je uneseno više od 5 znakova u input "Company VAT", provjerava svaki Company VAT i AUTOFILL-a
    if (variable.name === 'CompanyVAT' && companyVAT.length > 5) {
      let altVatCompany = null;
      reachedCompanies.forEach((company) => {
        if (company.VAT === companyVAT) {
          autoFillByVAT(company);
        }
        if (company.altVat === companyVAT) {
          altVatCompany = company;
        }
      });
      altVatCompany !== companybyAltVat && setCompanyByAltVat(altVatCompany);
    }

    if (variable.name === 'CompanyVAT' && companyVAT.length <= 5) {
      setCompanyByAltVat(null);
    }
  };

  if (modalOn) {
    return (
      <>
        <div className='main-modal'>Loading...</div>
      </>
    );
  }

  //---------------------------------------- Automatska ispuna po VAT broju -----------------------------------------------------------------------
  const autoFillByVAT = (company: Companies) => {
    setDocumentVariables((prevDocumentVariables) => {
      const updatedDocumentVariables = [...prevDocumentVariables];

      updatedDocumentVariables.forEach((variable, index) => {
        if (variable.name === 'SupplierName' && company.name) updatedDocumentVariables[index] = { name: variable.name, value: company.name };
        if (variable.name === 'InvoiceGroup' && company.companyGroup)
          updatedDocumentVariables[index] = { name: variable.name, value: company.companyGroup as string };
        if (variable.name === 'ProcessID' && company.processTypeId) {
          reachedProcesses.forEach((process) => {
            if (process.Name?.includes(company.processTypeId as string)) {
              updatedDocumentVariables[index] = { name: variable.name, value: process.Name };
            }
          });
        }
        if (variable.name === 'InvoiceCurrency' && company.currency)
          updatedDocumentVariables[index] = { name: variable.name, value: company.currency };
        if (variable.name === 'CompanyVAT' && company.VAT !== variable.value) {
          updatedDocumentVariables[index] = { name: variable.name, value: company.VAT as string };
          setCompanyByAltVat(null);
        }
      });

      return updatedDocumentVariables;
    });
  };
  //-----------------------------------------------------------------------------------------------------------------------------------------------

  return (
    <div className='document'>
      {modalDelete && (
        <DeleteDocument documentIds={[documentId as string]} deleteSource={2} setModalDelete={setModalDelete} toastMessage={undefined} />
      )}
      <div className='document__data'>
        <form onSubmit={handleConfirm} className=''>
          <h3 className='font-h3-regular'>Review data</h3>
          <div className='document__data__name-and-delete margin-bottom-2'>
            <div className='document__name'>
              <h5 className='font-h5-regular font-light margin-bottom-0'>{documentName}</h5>
              <span className='document__external-icon'>
                {/* na prvom mjestu u polju "documentFiles" je PDF file, a svi ostali su slike iz tog PDF-a */}
                {/*
                 <a download={documentFiles[0].name} href={`data:application/pdf;base64,${documentFiles[0].content}`}>
                  <img className='document__external-icon__img' src={ExternalIcon} alt='' />
                 </a> */}
                {documentFiles[0] && (
                  <span onClick={openPDFInNewTab}>
                    <img className='document__external-icon__img pointer' src={ExternalIcon} alt='' />
                  </span>
                )}
              </span>
            </div>
            <span className=' document__delete-button pointer' onClick={() => setModalDelete(true)}>
              <img src={BinIcon} alt='' />
              <span className='font-light color-white'>Delete</span>
            </span>
          </div>
          <div className='full-width-line-dark-300 margin-bottom-2 margin-top-2' />

          <div className='manage-document-data'>
            {documentVariables.map((variable, index) => {
              const name = variable.name;
              const correspondingVariable = documentVariableNames.find((item) => item.key === name);
              if (
                correspondingVariable &&
                (correspondingVariable.label === 'ID' ||
                  correspondingVariable.label === 'Name' ||
                  correspondingVariable.label === 'Company name' ||
                  correspondingVariable.label === 'Size' ||
                  correspondingVariable.label === 'Uploaded by' ||
                  correspondingVariable.label === 'Uploaded at' ||
                  // correspondingVariable.label === 'Modified by' ||
                  correspondingVariable.label === 'Modified at' ||
                  correspondingVariable.label === 'Status' ||
                  correspondingVariable.label === 'Dms ID' ||
                  correspondingVariable.label === 'Invoice type' ||
                  correspondingVariable.label === 'Invoice state' ||
                  correspondingVariable.label === 'Invoice order number' ||
                  correspondingVariable.label === 'Invoice reference number' ||
                  correspondingVariable.label === 'Invoice confirmation number' ||
                  // correspondingVariable.label === 'Invoice comment' ||
                  correspondingVariable.label === 'Invoice recipient')
              )
                return;
              if (variable.name === 'UploadedAt' || variable.name === 'ModifiedAt') {
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor=''>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <span className='bg-dark-300 color-white manage-document-data__input'>
                      {pretvoriDatumuFormatTablice(variable.value, `Invalid date`) || ''}
                    </span>
                  </React.Fragment>
                );
              }
              if (variable.name === 'ModifiedBy') {
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor=''>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <input
                      disabled
                      className='bg-dark-300 color-white manage-document-data__input'
                      // type='text'
                      value={variable.value || ''}
                      onChange={(e) => {
                        setDocumentVariables((prevDocumentVariables) => {
                          const updatedDocumentVariables = [...prevDocumentVariables];
                          updatedDocumentVariables[index] = { name: variable.name, value: e.target.value };

                          return updatedDocumentVariables;
                        });
                      }}
                    />
                  </React.Fragment>
                );
              }

              let textareaRows = 1;
              if (variable.value) textareaRows = variable.value.length / 24 + 1;

              //    Ova je komponenta pripremljena isključivo za 2 renderiranja i to za "invoiceDate i invoiceDueDate".
              //    Ukoliko je potrebno više renderiranja za još neke varijable,
              //    potrebno je izmijeniti uvjet, activeCalendar state i ref !!!
              if (variable.name === 'InvoiceDate' || variable.name === 'InvoiceDueDate') {
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor=''>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <div className='bg-dark-300 color-white manage-document-data__input flex-space-between relative'>
                      <span>{pretvoriDatumuFormatTabliceSimple(variable.value, `Invalid date`) || ''}</span>
                      {editable && (
                        <div className='filters__date' ref={variable.name === 'InvoiceDate' ? invoiceDateCalendarRef : invoiceDueDateCalendarRef}>
                          <img
                            className='filters__date__icon'
                            onClick={() => {
                              if (activeCalendar === 0 && variable.name === 'InvoiceDate') setActiveCalendar(1);
                              else if (activeCalendar === 0 && variable.name === 'InvoiceDueDate') setActiveCalendar(2);
                              else setActiveCalendar(0);
                            }}
                            src={calendarIcon}
                            alt='Calendar'
                          />
                          {((activeCalendar === 1 && variable.name === 'InvoiceDate') ||
                            (activeCalendar === 2 && variable.name === 'InvoiceDueDate')) && (
                            <div className='filters__date__calendar'>
                              <Calendar
                                onChange={(event) => {
                                  setDocumentVariables((prevDocumentVariables) => {
                                    const updatedDocumentVariables = [...prevDocumentVariables];
                                    updatedDocumentVariables[index] = {
                                      name: variable.name,
                                      value: searchRequestDate(event as Date, true) as string,
                                    };

                                    return updatedDocumentVariables;
                                  });
                                }}
                                value={variable.value}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div className='control-error'>
                        {variable.name === 'InvoiceDate' && invoiceDateIsInvalid && <p>Invoice date should be today or before.</p>}
                        {variable.name === 'InvoiceDueDate' && invoiceDueDateIsInvalid && (
                          <Tippy content="Invoice due date should be greater than invoice date, and shouldn't be greater than one year .">
                            <p>Invoice due date should be greater than invoice date, and shouldn't be greater than one year .</p>
                          </Tippy>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                );
              }
              if (variable.name === 'ProcessID') {
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor='processes'>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <select
                      className='form__item__input font-h5-regular max-width-240'
                      disabled={!editable}
                      name='processes'
                      id='processes'
                      onChange={(e) => {
                        setDocumentVariables((prevDocumentVariables) => {
                          const updatedDocumentVariables = [...prevDocumentVariables];
                          updatedDocumentVariables[index] = { name: variable.name, value: e.target.value };

                          return updatedDocumentVariables;
                        });
                      }}
                    >
                      <option value='' disabled selected={!variable.value}>
                        Choose an option
                      </option>
                      {reachedProcesses.map((process) => {
                        const isSelected: boolean = (variable.value !== '' && variable.value && process.Name?.includes(variable.value)) as boolean;
                        // const currentProcID = process.Name?.split(' ')[0];
                        return (
                          <option selected={isSelected} key={process.Id} value={process.Name as string}>
                            {process.Name}
                          </option>
                        );
                      })}
                    </select>
                  </React.Fragment>
                );
              }
              if (variable.name === 'InvoiceGroup') {
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor='InvoiceGroups'>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <select
                      className='form__item__input font-h5-regular max-width-240'
                      disabled={!editable}
                      name='InvoiceGroups'
                      id='InvoiceGroups'
                      onChange={(e) => {
                        setDocumentVariables((prevDocumentVariables) => {
                          const updatedDocumentVariables = [...prevDocumentVariables];
                          updatedDocumentVariables[index] = { name: variable.name, value: e.target.value };

                          return updatedDocumentVariables;
                        });
                      }}
                    >
                      <option value='' disabled selected={variable.value !== 'DOM' && variable.value !== 'INO'}>
                        Choose an option
                      </option>
                      <option selected={variable.value === 'DOM'} value={'DOM'}>
                        DOM
                      </option>
                      <option selected={variable.value === 'INO'} value={'INO'}>
                        INO
                      </option>
                    </select>
                  </React.Fragment>
                );
              }
              if (variable.name === 'InvoiceTotal' || variable.name === 'InvoiceSubtotal') {
                const regex = /^-?$|^-?\d+(\.\d{0,2})?$/;
                return (
                  <React.Fragment key={index}>
                    <label className='color-white' htmlFor=''>
                      {correspondingVariable && correspondingVariable.label}
                    </label>
                    <div className='bg-dark-300 color-white flex-space-between border-radius-4 relative'>
                      <textarea
                        name={correspondingVariable?.label}
                        rows={textareaRows}
                        disabled={!editable} //update confirmed uneditable
                        className='bg-dark-300 color-white manage-document-data__input full-width'
                        // type='text'
                        value={variable.value || ''}
                        onChange={(event) => {
                          if (regex.test(event.target.value) || event.target.value === '') handleInputChange(event, index, variable);
                        }}
                      />
                      <div className='control-error'>
                        {variable.name === 'InvoiceTotal' && invoiceTotalIsInvalid && <p>Wrong format.</p>}
                        {variable.name === 'InvoiceSubtotal' && invoiceSubtotalIsInvalid && <p>Wrong format.</p>}
                      </div>
                    </div>
                  </React.Fragment>
                );
              }
              const regex = /^[^\n\r]*$/;
              return (
                <React.Fragment key={index}>
                  <label className='color-white' htmlFor=''>
                    {correspondingVariable && correspondingVariable.label}
                  </label>
                  <div className='bg-dark-300 color-white flex-space-between border-radius-4 relative'>
                    <textarea
                      name={correspondingVariable?.label}
                      rows={textareaRows}
                      disabled={!editable || variable.name === 'CompanyName'} //update confirmed uneditable
                      className='bg-dark-300 color-white manage-document-data__input  full-width'
                      // type='text'
                      value={variable.value || ''}
                      onChange={(event) => {
                        if (regex.test(event.target.value) || event.target.value === '') handleInputChange(event, index, variable);
                      }}
                    />
                    {variable.name === 'CompanyVAT' && companybyAltVat && (
                      <div className='control-error pointer'>
                        <p onClick={() => autoFillByVAT(companybyAltVat)}>Click to take primary VAT.</p>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
          <div className='full-width-line-dark-300 margin-bottom-2 margin-top-2' />
          {editable && (
            <div className='flex-gap-1 margin-bottom-2'>
              <button
                disabled={invoiceDateIsInvalid || invoiceDueDateIsInvalid || invoiceSubtotalIsInvalid || invoiceTotalIsInvalid}
                className='button-primary flex-basis-65'
              >
                Confirm
              </button>
              <button
                disabled={invoiceDateIsInvalid || invoiceDueDateIsInvalid || invoiceSubtotalIsInvalid || invoiceTotalIsInvalid}
                type='button'
                className='button-primary flex-basis-35'
                onClick={handleConfirmAndNext}
              >
                Confirm & Next
              </button>
            </div>
          )}
          <div className='flex-space-between flex-gap-1 manage-buttons-2'>
            <button type='button' onClick={goBack} className='button-secondary'>
              Cancel
            </button>
            {editable && (
              <button type='button' className='button-secondary' onClick={nextDocument}>
                Skip
              </button>
            )}
          </div>
        </form>
      </div>
      <DocumentImages files={documentFiles} />
    </div>
  );
};
